// Ecran verrouille / centre de controle / CarPlay : sans metadonnees explicites,
// iOS remplit la fiche du lecteur avec le hostname de la page ("localhost" en dev,
// l'hote Capacitor en natif) et laisse la pochette vide. On la renseigne des qu'un
// backing est charge, et on tient playbackState a jour parce que la lecture bascule
// sur Web Audio (boucle gapless) pendant que l'element <audio> reste en pause :
// sans ca le systeme afficherait "en pause" alors que le morceau tourne.

const FALLBACK_ARTWORK = `${process.env.PUBLIC_URL || ''}/logo512.png`;

const hasMediaSession = () =>
  typeof navigator !== 'undefined' &&
  'mediaSession' in navigator &&
  typeof window !== 'undefined' &&
  typeof window.MediaMetadata === 'function';

export const setNowPlaying = ({ title, artist, artwork } = {}) => {
  if (!hasMediaSession()) return;
  navigator.mediaSession.metadata = new window.MediaMetadata({
    title: title || 'upScale',
    artist: artist || 'upScale',
    album: 'upScale',
    // L'avatar distant n'a ni taille ni type connus : on les omet plutot que
    // d'annoncer une dimension fausse (iOS redimensionne lui-meme).
    artwork: artwork
      ? [{ src: artwork }]
      : [{ src: FALLBACK_ARTWORK, sizes: '512x512', type: 'image/png' }],
  });
};

export const setNowPlayingState = (isPlaying) => {
  if (!hasMediaSession()) return;
  navigator.mediaSession.playbackState = isPlaying ? 'playing' : 'paused';
};

// Les boutons de l'ecran verrouille doivent piloter NOTRE transport : un pause
// systeme qui n'irait qu'a l'element <audio> laisserait la boucle Web Audio jouer.
// piste precedente/suivante restent non gerees (grisees) : il n'y a pas de file.
const HANDLED = ['play', 'pause', 'stop'];
const IGNORED = ['previoustrack', 'nexttrack', 'seekbackward', 'seekforward', 'seekto'];

export const setNowPlayingHandlers = ({ play, pause, stop } = {}) => {
  if (!hasMediaSession()) return;
  const handlers = { play, pause, stop };
  [...HANDLED, ...IGNORED].forEach((action) => {
    try {
      navigator.mediaSession.setActionHandler(action, handlers[action] || null);
    } catch (e) {
      // Action non supportee par le navigateur : rien a faire
    }
  });
};

export const clearNowPlaying = () => {
  if (!hasMediaSession()) return;
  setNowPlayingHandlers({});
  navigator.mediaSession.metadata = null;
  navigator.mediaSession.playbackState = 'none';
};
